export default __webpack_public_path__ + "static/media/banner2.7b688f1e.jpg";